/**
 * Feature flags with JSON payloads (not enum variants).
 * Add a key + expected payload shape here to get type-safe `getFlagPayload` calls.
 */
export const PH_PAYLOAD_FEATURES = {} as const;

export type PH_PayloadFeatures = typeof PH_PAYLOAD_FEATURES;

export const PH_FEATURES = {
    'plp-cards': ['control', 'redesign'],
    'plp-filter-sidebar': ['control', 'sidebar'],
    'alternate-elastic-weights': ['control', 'alternate-elastic-weights'],
    'simplified-checkout': ['control', 'simplified'],
    'alternate-homepage': ['control', 'home-alternate'],
    'google-review-badge': ['control', 'pdp-only', 'fixed'],
    'checkout-info-no-start-date': ['control', 'no-required-date-time'],
    'checkout-info-page': ['control', 'no-required-date-time'],
    'pdp-recommendations': ['control', 'pdp-recommendations'],
    'pdp-location-details': ['control', 'without-cities'],
    'pdp-nudging': ['control', 'stats', 'pills', 'reviews'],
    'plp-extra-filters': ['control', 'enabled'],
    'plp-finetuning': ['control', 'finetuning'],
} as const;
